import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'mojo-dashboard-filters',
  styleUrls: ['./dashboard-filters.component.scss'],
  templateUrl: './dashboard-filters.component.html',
})
export class DashboardFiltersComponent {
  @Output() changeJobStatusFilter = new EventEmitter();
  @Output() functionAndDepartmentsFilters = new EventEmitter();

  changeFunctionAndDepartmentsFilters(event) {
    this.functionAndDepartmentsFilters.emit({
      selectedFunction: event.selectedFunction,
      selectedDepartment: event.selectedDepartment,
    });
  }

  changeJobStatus(status) {
    this.changeJobStatusFilter.emit(status);
  }
}
